import Carousel from '../components/Carousel';
import Slider from '../components/Slider';
import { $ } from '../util/DOM';

const getLinkHtml = (el) => {
  const qs = el.getAttribute('data-link-content');
  if (!qs) {
    return '';
  }
  const content = el.querySelector(qs);
  if (!content) {
    return '';
  }
  return content.innerHTML;
}; 

const sliderControlComponents = {
  arrows: (slider) => $.render('div', {
    className: 'slider-controls__arrows',
    children: [
      $.render('button', {
        type: 'button',
        className: 'prev',
        attrs: { 'aria-label': 'Voltar slide' },
        innerHTML: /* html */ `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02943 7.02944 3 12 3C16.9706 3 21 7.02943 21 12Z" fill="#F6EA01"/>
<path d="M11.9856 24C17.5776 24 22.5665 19.9857 23.7363 14.5193C24.3207 11.788 23.927 8.8836 22.6231 6.41216C21.3682 4.03366 19.311 2.11136 16.8496 1.02194C14.2893 -0.111503 11.35 -0.309022 8.65904 0.463935C6.06295 1.20937 3.76107 2.84549 2.19392 5.04175C-1.08272 9.63333 -0.644633 16.083 3.21032 20.1973C5.46965 22.6085 8.67864 24 11.9856 24ZM6.22123 11.3578L9.49695 8.0073C10.3263 7.15882 11.6372 8.44423 10.8112 9.28874L9.15836 10.9793L16.9913 10.9793C17.5476 10.9793 18.0117 11.4431 18.0117 11.9984C18.0117 12.5536 17.5473 13.0175 16.9913 13.0175L9.19755 13.0175L10.8832 14.7007C11.7208 15.5372 10.4221 16.8345 9.58451 15.998L6.22888 12.6469C5.87314 12.2919 5.86978 11.7171 6.22123 11.3578Z" fill="#012A60"/>
</svg>
`,
        events: {
          click: () => {
            slider.goPrev();
          },
        },
      }),
      $.render('button', {
        type: 'button',
        className: 'next',
        attrs: { 'aria-label': 'Avançar slide' },
        innerHTML: /* html */ `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" fill="#F6EA01"/>
<path d="M12.0144 0C6.42241 0 1.43351 4.0143 0.263735 9.48065C-0.320691 12.212 0.0730087 15.1164 1.37687 17.5878C2.63175 19.9663 4.68903 21.8886 7.15041 22.9781C9.71069 24.1115 12.65 24.309 15.341 23.5361C17.937 22.7906 20.2389 21.1545 21.8061 18.9582C25.0827 14.3667 24.6446 7.917 20.7897 3.80272C18.5304 1.39151 15.3214 0 12.0144 0ZM17.7788 12.6422L14.503 15.9927C13.6737 16.8412 12.3628 15.5558 13.1888 14.7113L14.8416 13.0207H7.00867C6.45241 13.0207 5.9883 12.5569 5.9883 12.0016C5.9883 11.4464 6.45272 10.9825 7.00867 10.9825H14.8025L13.1168 9.29934C12.2792 8.46278 13.5779 7.16545 14.4155 8.00201L17.7711 11.3531C18.1269 11.7081 18.1302 12.2829 17.7788 12.6422Z" fill="#012A60"/>
</svg>
`,
        events: {
          click: () => {
            slider.goNext();
          },
        },
      }),
    ],
  }),
  counters: (slider) => {
    const children = slider.children.map((el, i) => $.render('button', {
      type: 'button',
      textContent: i + 1,
      attrs: { 'aria-label': `Ver o slide ${i + 1}` },
      events: { click: () => slider.goTo(i) },
    }));

    slider.on('render', () => {
      children.forEach((btn, btnIndex) => {
        if (btnIndex === slider.index) {
          btn.classList.add('is-active');
        } else {
          btn.classList.remove('is-active');
        }
      });
    });

    return $.render('div', {
      className: 'slider-controls__counters',
      children,
    });
  },
  links: (slider) => {
    const children = slider.children.map((el, i) => $.render('div', {
      innerHTML: getLinkHtml(el),
      tabindex: '-1',
      events: { click: () => slider.goTo(i) },
    }));

    slider.on('render', () => {
      children.forEach((btn, btnIndex) => {
        if (btnIndex === slider.index) {
          btn.classList.add('is-active');
        } else {
          btn.classList.remove('is-active');
        }
      });
    });

    return $.render('div', {
      className: 'slider-controls__links',
      children,
    });
  },
};

const generateControls = (slider, keys) => keys.map((key) => {
  if (!(key in sliderControlComponents)) {
    // eslint-disable-next-line no-console
    console.warn(`Opção de controle inválida: ${key}. As opções disponíveis são ${
      Object.keys(sliderControlComponents).join(', ')
    }`);
    return null;
  }
  return sliderControlComponents[key](slider);
});

const setSliderControls = (slider, controlOptions) => {
  if (!controlOptions) {
    return;
  }
  const controlKeys = controlOptions.trim().split(' ');
  if (!controlKeys.length) {
    return;
  }

  const container = $.render('div', {
    className: 'slider-controls__container',
    children: generateControls(slider, controlKeys),
  });

  slider.container.insertAdjacentElement('afterEnd', container);
};

const createSlider = (container, type) => {
  const play = container.hasAttribute('data-play');
  const interval = container.getAttribute('data-interval') || 3000;
  const height = container.getAttribute('data-height');
  const controls = container.getAttribute('data-controls');

  const slider = (
    type === 'carousel'
      ? new Carousel(container, { interval })
      : new Slider(container, { interval })
  );

  if (play) {
    slider
      .on('mouseover', () => slider.pause())
      .on('mouseout', () => slider.play())
      .play();
  }

  if (height) {
    slider.container.style.height = height;
  }

  if (controls) {
    setSliderControls(slider, controls);
  }

  return slider;
};

const createCarousel = (container) => {
  createSlider(container, 'carousel');
};

const initSliders = () => {
  $('.slider').forEach(createSlider);
  $('.carousel').forEach(createCarousel);
};

export default initSliders;
